import React, { useEffect, useState, useContext } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { generatePath, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Row, Col, Button, CloseButton } from "react-bootstrap";
import { MultiSelectDropdown, SelectInput } from "../../InputComponents";
import { AppUtil } from "../../../utils/app.utils";
import { MASTER_DATA_KEYS as MDK } from "../../../utils/constants";
import { MasterDataContext } from "../../../contexts";
import { getSamplesListForWorkflow } from "../../../services/Workflow";
import Form from 'react-bootstrap/Form';
import { trackPromise, usePromiseTracker } from "react-promise-tracker";
import { AxiosResponse } from "axios";
import * as _ from 'lodash';
import { InfoCircle } from "react-bootstrap-icons";
import { appRoutes } from "../../../utils/routes";

type MultSelectItem = {
    label: string
    value: string | number
}

export const CreateWorkflow = ({ isCallFetchAPI, setIsCallFetchAPI }: { isCallFetchAPI: boolean, setIsCallFetchAPI: (vale: boolean) => void }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const formMethods = useFormContext()
    const { patientId, id } = useParams()
    const { masterData } = useContext(MasterDataContext)

    const { getValues, setValue, watch } = formMethods
    const translatn = "workflowContainer.";
    const [options, setOptions] = useState<MultSelectItem[]>([]);
    const { promiseInProgress } = usePromiseTracker({ area: 'draft-samples-loading' });

    let workflowValue = watch('workflowName');
    let draftSamples = watch('draftSamples');

    const handleGetSampleListCall =()=> {
        trackPromise(getSamplesListForWorkflow(patientId, workflowValue).then(
            (res: AxiosResponse) => {
                if (res.status == 200) {
                    const fetchedOptions = res.data.map((item: any) => ({
                        label: item.id,
                        value: item.id,
                    }));
                    setOptions(fetchedOptions);
                    setIsCallFetchAPI(false)
                }
            },
            (error) => {
                AppUtil.logError(error)
            },
        ), 'draft-samples-loading')
    }

    useEffect(() => {
        if (patientId && masterData.length) {
            setValue('workflowName', getValues('workflowName'))
        }
    }, [masterData])

    useEffect(() => {
        if (!workflowValue) {
            setOptions([])
            setValue('sampleIDs', [])
        } else if(patientId && workflowValue && !isCallFetchAPI){
            handleGetSampleListCall()
        }
    }, [workflowValue])

    useEffect(() => {
        if (patientId && workflowValue && isCallFetchAPI) {
            handleGetSampleListCall()
        }
    }, [patientId, workflowValue, isCallFetchAPI])

    const handleRemove = (value: string) => {
        if(!promiseInProgress) {
            const result = _.replace(draftSamples, value, '');
            formMethods.setValue('draftSamples', _.compact(_.split(result, ',')).join(','))
            formMethods.setValue('removedSamples', _.compact(_.split(getValues('removedSamples') + ',' + value, ',')).join(','))
            if (value) {
                const newObj = { label: value, value: value }
                if (!_.find(options, newObj)) {
                    const output = _.concat(options, newObj);
                    setOptions(output)
                }
            }
        }        
    }

    return (
        <>
            <Row>
                <Col>
                    <SelectInput
                        name={"workflowName"}
                        id="workflowName"
                        title={t(`${translatn}workflowName`)}
                        placeholder={t(`${translatn}workflowName`)}
                        required={true}
                        optionsValueArray={AppUtil.getOptions(MDK.TEST_TYPE, masterData)}
                        disabled={true/* !!id */}
                    />
                </Col>
                <Col>
                    <MultiSelectDropdown
                        name="sampleIDs"
                        id="sampleIDs"
                        title={t(`${translatn}sampleIdsInDraft`)}
                        placeholder={t(`${translatn}sampleIdsInDraftPlaceholder`)}
                        required={true}
                        optionsValueArray={options}
                        hideSelectedValues={false}
                        disabled={false}
                        loading={promiseInProgress}
                    />
                </Col>
            </Row>
            {id && !!_.compact(_.split(watch('draftSamples'), ',')).length && <Row>
                <Col>
                    <Form.Label htmlFor={id}><span>
                        Associated Sample ID(s)
                    </span></Form.Label>
                    <Row className="d-flex mt-1">
                        <Col className="d-flex flex-wrap">
                            <Controller
                                name={'associated_sample_ids'}
                                render={() => {
                                    return (
                                        <>
                                            {
                                                _.compact(_.split(watch('draftSamples'), ','))?.map((ds: string, index: number) => {
                                                    return <><Button variant="outline-secondary" className="d-flex align-items-center me-1 mb-1" key={index}>{ds} <CloseButton onClick={() => handleRemove(ds)} /></Button><sup><InfoCircle title="View details of this sample" style={{cursor: 'pointer'}} onClick={() => navigate(
                                                                              generatePath(appRoutes.viewSample, {
                                                                                patientId: patientId,
                                                                                id: ds,
                                                                              }), {state:'workflow'}
                                                                            )}/></sup></>
                                                })}
                                        </>
                                    )
                                }}></Controller>
                        </Col>

                    </Row>

                </Col>
            </Row>
            }

        </>
    );
};